import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark pt-20 pb-8 px-6 relative overflow-hidden" data-id="element-248" data-mp="32wd2cf6gdjt0">
      {/* Gradient Top Border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal/30 to-transparent" data-id="element-249" data-mp="3ghc2o28413o8" />

      {/* Subtle Ambient Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-purple/5 rounded-full blur-[100px] pointer-events-none" data-id="element-250" data-mp="36qhgsyys063b" />

      <div className="inner-container relative z-10" data-id="element-251" data-mp="3ucxsgbm63rhp">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-252" data-mp="37o7iyd163ey">
          {/* Col 1 */}
          <div data-id="element-253" data-mp="3ldkdx4j6scq4">
            <a href="/" className="flex items-center gap-2 mb-4" data-id="element-254" data-mp="3le2jwsvni5b8">
              <img src="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" alt="MINDStream.ing icon" className="h-9 w-9 rounded-lg" data-id="element-255" data-mp="3qcdsz1e4gbse" />
              <span className="font-poppins text-2xl font-extrabold tracking-tight" data-id="element-256" data-mp="2evxaez79tf1b">
                <span style={{
                color: '#3D32AE'
              }} data-id="element-257" data-mp="3lbmttrbgd6fd">
                  MIND
                </span>
                <span className="text-teal font-medium" data-id="element-258" data-mp="3v8hp81cfiqpf">stream</span>
                <span style={{
                color: '#3D32AE'
              }} className="italic font-bold" data-id="element-259" data-mp="3q83rpd8gez5n">
                  .ing
                </span>
              </span>
            </a>
            <p className="font-poppins font-semibold text-white/90 mb-4" data-id="element-260" data-mp="31uplihsodpw">
              Your Business. Running Itself.
            </p>
            <p className="text-sm text-steel leading-relaxed" data-id="element-261" data-mp="cu0icufvez65">
              MR is your AI chief of operations. It manages your projects, runs
              your team, coordinates clients, and executes across your entire
              business — 24/7.
            </p>
          </div>

          {/* Col 2 */}
          <div data-id="element-262" data-mp="tvmpxgmhyeld">
            <h4 className="font-poppins font-semibold text-white mb-6" data-id="element-263" data-mp="tw5yw7u65sn9">
              Product
            </h4>
            <ul className="space-y-3 text-sm text-steel" data-id="element-264" data-mp="yuzeq6wxhvql">
              <li data-id="element-265" data-mp="13tkc7yksq1bc">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-266" data-mp="13t0sqdfhz4v7">
                  Features
                </a>
              </li>
              <li data-id="element-267" data-mp="18lbvrp5jb6rz">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-268" data-mp="18ltwoz356968">
                  Pricing
                </a>
              </li>
              <li data-id="element-269" data-mp="1hjw4pylam230">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-270" data-mp="1hje64vb5rbrx">
                  Integrations
                </a>
              </li>
              <li data-id="element-271" data-mp="1riv56tvwmrex">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-272" data-mp="1rjenwctdpju0">
                  How It Works
                </a>
              </li>
              <li data-id="element-273" data-mp="3oczpzct5yl73">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-274" data-mp="3odhusxtw67qm">
                  ThinkTank
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-275" data-mp="2ah824nnoyura">
            <h4 className="font-poppins font-semibold text-white mb-6" data-id="element-276" data-mp="25of22d364alj">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-steel" data-id="element-277" data-mp="21mjyf1xrll4l">
              <li data-id="element-278" data-mp="21n1xe6btadg7">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-279" data-mp="1wnp87exgwuag">
                  About
                </a>
              </li>
              <li data-id="element-280" data-mp="2te99gf4px6ye">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-281" data-mp="2tcoewpielo0j">
                  Partners
                </a>
              </li>
              <li data-id="element-282" data-mp="2kdb67z23t3gv">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-283" data-mp="2kcrz7ddzrzhm">
                  Community
                </a>
              </li>
              <li data-id="element-284" data-mp="2fdosloid5l7j">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-285" data-mp="2fgay7ilp1qn4">
                  Blog
                </a>
              </li>
              <li data-id="element-286" data-mp="13yib8kdnwcrb">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-287" data-mp="13y04uuxaci5o">
                  Contact
                </a>
              </li>
              <li data-id="element-288" data-mp="2rtmtc47oe91c">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-289" data-mp="2wmfxoqz8ffcw">
                  Security
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4 */}
          <div data-id="element-290" data-mp="2nu5nh9oc79vn">
            <h4 className="font-poppins font-semibold text-white mb-6" data-id="element-291" data-mp="2ntw5a89ja70i">
              Resources
            </h4>
            <ul className="space-y-3 text-sm text-steel" data-id="element-292" data-mp="3bjgrr14wbmej">
              <li data-id="element-293" data-mp="3bhvydeubi9i9">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-294" data-mp="3fl21weq1pml1">
                  Case Studies
                </a>
              </li>
              <li data-id="element-295" data-mp="31krbtdwk8c0x">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-296" data-mp="31laoaf3fy87k">
                  VS Competitors
                </a>
              </li>
              <li data-id="element-297" data-mp="1q5uhbohlwum6">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-298" data-mp="1q5caxz18d00j">
                  Enterprise
                </a>
              </li>
              <li data-id="element-299" data-mp="1v343mv9p8q5s">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-300" data-mp="1nlpgqks44rmx">
                  Documentation
                </a>
              </li>
              <li data-id="element-301" data-mp="1im33ibcabbe4">
                <a href="#" className="hover:text-teal transition-colors" data-id="element-302" data-mp="1iml57nhpuhtf">
                  Affiliate Program
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 relative flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-steel" data-id="element-303" data-mp="1rocbouk2ysoc">
          {/* Gradient Divider */}
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-304" data-mp="zx682455icub" />

          <p data-id="element-305" data-mp="1dojmx4s46mj0">© 2026 MINDstream.ing — Ad ROI, LLC. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-306" data-mp="18wt9ur1slknw">
            <a href="#" className="hover:text-white transition-colors" data-id="element-307" data-mp="18vqmuu7lc2d9">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-308" data-mp="l54c2v67c3zk">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}